import type { ISerialize } from '@/objects/ISerialize';

export class EnableTimeRequest implements ISerialize {
    public TUID: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { TUID?: string | null }) {
        this.TUID = values.TUID ?? '';
    }

    public serialize(): string {
        return '{' + `"TUID": ${JSON.stringify(this.TUID)}` + '}';
    }

    /**
     * Creates an instance of EnableTimeRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { TUID?: string | null }): EnableTimeRequest {
        return new EnableTimeRequest(values);
    }

    public static _FromServerJson(json: any): EnableTimeRequest {
        return new EnableTimeRequest({ TUID: json.TUID ?? '' });
    }

    /**
     * Creates an instance of EnableTimeRequest from another instance of EnableTimeRequest.
     * @param other The EnableTimeRequest you want to clone
     * @returns A cloned EnableTimeRequest
     */
    public static FromOther(other: EnableTimeRequest): EnableTimeRequest {
        return EnableTimeRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return EnableTimeRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'EnableTimeRequest';
}
